import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import '../../../../App.css';
import SpText from '../../../../components/atoms/SpText';
import { CircularProgress, Grid } from '@material-ui/core';
import { withSnackbar } from '../../../../components/atoms/SpSnackBar';
import { SpLoader } from '../../../../components/atoms/SpLoader';
import { theme as themeStyle } from '../../../../components/theme';
import { Person, CalendarToday, Build, DirectionsBike, Euro } from '@material-ui/icons';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { UserSessionContext } from '../../../../App';
moment.locale('it');

const useStyles = makeStyles((theme) => ({
  colorPrimary: {
    marginTop: '20%',
    alignSelf: 'center',
    position: 'relative',
    height: 10,
    color: '#006E2D',
    borderRadius: 50,
    variant: 'indeterminate',
    background: 'transparent',
    '& .MuiCircularProgress-colorPrimary': {
      backgroundColor: '#006E2D'
    },
    '& .MuiCircularProgress-barColorPrimary': {
      backgroundColor: 'white'
    }
  },
  text: {
    margin: '0 auto'
  }
}));

const StationClosedRentDetailDialog = (props) => {
  const [rentBikePhotos, setRentBikePhotos] = useState([]);
  const [photoLoading, setPhotoLoading] = useState(true);
  const { selectedRent } = props;
  const classes = useStyles();
  const { authData, setAuthData } = useContext(UserSessionContext);
  console.log(selectedRent);
  const LabelValue = (props) => (
    <Grid
      item
      xs
      container
      direction="row"
      style={{ flexGrow: 0, marginBottom: '2px' }}
    >
      <Grid
        item
        xs={2}
      >
        <SpText variant="dialogReservationDetailTitle">{props.label + ':'}</SpText>
      </Grid>
      <Grid
        item
        xs
      >
        <SpText variant="text">{props.value}</SpText>
      </Grid>
    </Grid>
  );
  console.log('selectedRent', selectedRent);
  const setAllBikesPhotos = async () => {
    try {
      let rentBikePhotosData = [];
      selectedRent.rent.rent_bikes.map( (elem) => {
        console.log('elem', elem);
        const fileURL = elem?.file?.url;
        rentBikePhotosData.push({ fileURL: fileURL, bikeCode: elem?.bike?.code });
      });
      console.log('1', rentBikePhotosData);

      setRentBikePhotos(rentBikePhotosData);
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  useEffect(() => {
    setAllBikesPhotos();
  }, []);

  return (
    <Grid
      container
      direction="row"
    >
      <Grid
        item
        xs={5}
        container
        direction="column"
      >
        {rentBikePhotos.map((photo) => (
          <Grid
            item
            xs
            container
            direction="column"
            justifyContent="flex-start"
          >
            <LabelValue
              label="Bicicletta"
              value={photo.bikeCode}
            />
            {photo.fileURL && photoLoading && (
              <CircularProgress
                size={60}
                className={classes.colorPrimary}
              />
            )}
            {photo.fileURL && (
              <img
                src={photo.fileURL}
                onLoad={() => setPhotoLoading(false)}
                style={{ width: '300px', height: photo.fileURL && photoLoading == false ? '300px' : '0px', visibility: photo.fileURL && photoLoading == false ? 'visible' : 'hidden' }}
              />
            )}
            {!photo.fileURL && <SpText>Non è stata associata un'immagine a questo noleggio.</SpText>}
          </Grid>
        ))}
      </Grid>
      <Grid
        item
        xs={7}
        container
        direction="column"
      >
        <Grid
          item
          xs
          container
          direction="row"
        >
          <Grid
            item
            xs={1}
          >
            <Person style={{ color: themeStyle.colors.mainGreen.main }} />
          </Grid>
          <Grid
            item
            xs={11}
          >
            <SpText variant="dialogRentDetail">{selectedRent?.user?.email}</SpText>
          </Grid>
        </Grid>
        <Grid
          item
          xs
          container
          direction="row"
        >
          <Grid
            item
            xs={1}
          >
            <CalendarToday style={{ color: themeStyle.colors.mainGreen.main }} />
          </Grid>
          <Grid
            item
            xs={11}
          >
            <SpText variant="dialogRentDetail">{`Da ${moment(selectedRent?.rent.start_date).format('DD/MM/YYYY HH:MM')} a ${moment(selectedRent?.rent.end_date).format('DD/MM/YYYY HH:MM')}`}</SpText>
          </Grid>
        </Grid>
        <Grid
          item
          xs
          container
          direction="row"
        >
          <Grid
            item
            xs={1}
          >
            <Build style={{ color: themeStyle.colors.mainGreen.main }} />
          </Grid>
          <Grid
            item
            xs={11}
          >
            <SpText variant="dialogRentDetail">{`Segnalazioni: ${selectedRent?.rent?.reports?.length}`}</SpText>
          </Grid>
        </Grid>
        <Grid
          item
          xs
          container
          direction="row"
        >
          <Grid
            item
            xs={1}
          >
            <DirectionsBike style={{ color: themeStyle.colors.mainGreen.main }} />
          </Grid>
          <Grid
            item
            xs={11}
          >
            <SpText variant="dialogRentDetail">{`Numero di bici noleggiate: ${selectedRent?.rent?.bikes?.length}`}</SpText>
          </Grid>
        </Grid>
        <Grid
          item
          xs
          container
          direction="row"
        >
          <Grid
            item
            xs={1}
          >
            <Euro style={{ color: themeStyle.colors.mainGreen.main }} />
          </Grid>
          <Grid
            item
            xs={11}
          >
            <SpText variant="dialogRentDetail">{`Importo noleggio: ${selectedRent?.rent?.user_payment ? selectedRent?.rent?.user_payment?.amount.toString() + '€' : '0€'}`}</SpText>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withSnackbar(StationClosedRentDetailDialog);
